export default "__VITE_ASSET__BuuTqHFj__"